import React, { Component } from 'react';
import Category from './Category'
import Snps from './Snps'
import Quote from './Quote'

class DocsFrontEnd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uid:null,
      token:null,
      listError:null,
      listLoaded:false,
      list: {}
    };
  }

  handleChange = (uid,token)=> {
    this.setState({uid,token});
    this.render();
  }

  componentDidMount() { 
    fetch("https://moreygenetics.com/json/example.json")
      .then(res=>res.json())
      .then(
        (result) => {
          this.setState({
            listLoaded:true,
            list:result
          });
        }, 
        (error) => {
          console.log(error);
          this.setState({
            listLoaded:true,
            listError:error
          });
        }
      )
      
  }

  render() {
    var List = this.state.list;
  
    return (
      this.state.listLoaded &&
        <>
          <div className="src_files">
            <a href='src/Quote.js'>Quote.js</a>
            <a href='src/PubButtons.js'>PubButtons.js</a>
            <a href='src/Snps.js'>Snps.js</a>
            <a href='src/Facebook.js'>Facebook.js</a>
            <a href='src/index.css'>index.css</a>
          </div>
        
          <p>
            The frontend on this website renders citations and quotes next to relevant links to resources such as NCBI, ensembl, ResearchGate, and Google Scholar, using a React component that I named <code>Quote</code>.
            <br/><br/>
            Another component, <code>Snps</code>, displays information about specific genetic variants taken from ensembl's database, and links to the appropriate information from ensembl, NCBI, SNPedia, and Google Scholar.
            <br/><br/>
            In the example below, the <code>Quote</code> component is used to cite a study that analyzed genetic variants to determine their effect on severe COVID-19.
            <br/><br/>
            Below the quote, the <code>Snps</code> component is used to display information about three of the variations from Table 1 of the same study.
          </p>
          
          <Category id={"Source"} info={List[decodeURIComponent("Source")]} token={this.state["token"]} uid={this.state.uid} /><br/>

          <p>
            The <code>Quote</code> component is called by the application using JSX syntax as in either of the two examples below.
            <br/><br/>
            It can be called with either a single dictionary prop called <code>info</code>, or by using individual props and placing the quote's text inside the JSX node.
            <br/><br/>
            Both will render the same way.
          </p>

          <pre>
{`  <Quote info={{
    "title":"Example",
    "authors":"Doe, John",
    "year":"XXXX",
    "text":"This is a quote"
  }}/>`}
          </pre>
          <pre>
{`  <Quote title="Example" authors="Doe, John" year="XXXX">
    This is a quote.
  </Quote>`}
          </pre>
          
          <Quote title="Example" authors="Doe, John" year="xxxx">
            This is a quote.
          </Quote>
         
          <p>
            The component's <code>render</code> method creates a dictionary called <code>citation</code>.
            <br/><br/>
            It checks to see whether the information was passed using the dictionary prop <code>info</code>.
            <br/><br/>
            If not, <code>this.props</code> is passed to an anonymous arrow function to destructure certain values and return them in a dictionary.
          </p>
          <a href="https://moreygenetics.com/src/Quote.js"
            target="_blank"
            rel="noopener noreferrer"
            style={{"fontWeight":"bold"}}>Quotes.js</a>
          <pre>{`
    let citation = {};
    if (this.props.info) {
      citation = this.props.info;
    } else {
      citation = (
        ({ title, authors, publisher, year, url, pubmed, pmc, researchgate, pdf, type }) => (
          { title, authors, publisher, year, url, pubmed, pmc, researchgate, pdf, type }
        )
      )(this.props);
      citation["text"] = this.props.children;
    }
          `}</pre>

          <p>
            Some of the values from the <code>citation</code> dictionary are destructured into variables called <code>authors</code>, <code>title</code>, <code>publisher</code>, <code>year</code>, and <code>text</code>.
            <br/><br/>
            The rest of the values are needed for the buttons on the left side of the div, so they are placed in a new dictionary called <code>button_values</code>.
            <br/><br/>
            The large <code>&ldquo;&nbsp;&rdquo;</code> marks are displayed using divs with <code>flex-direction:row</code>.  They are given className <code>quote-text-open</code> and <code>quote-text-close</code>.
          </p>
          <a href="https://moreygenetics.com/src/Quote.js"
            target="_blank"
            rel="noopener noreferrer"
            style={{"fontWeight":"bold"}}>Quote.js</a>
          <pre>{`
    let { authors, title, publisher, year, text, ...button_values } = citation;
    
    return(
      <div className="quote" key={title} style={{borderLeft:left_border}}>
        <div>
          <div className="title">
            <PubButtons {...button_values} title={title} />
            <div>{authors}. "{title}." <i>{publisher}</i>{publisher&&","} {year}.</div>
          </div>
          <div className="quote-text">
            <div className="quote-text-open">&ldquo;</div>
            <div className="quote-text-inner" dangerouslySetInnerHTML={{__html:text}}/>
            <div className="quote-text-close">&rdquo;</div>
          </div>
        </div>
      </div>
    );
          `}</pre>

          <p>
            Notice that in the code excerpt above, the information from the <code>button_values</code> dictionary is passed to another component called <code>PubButtons</code> using spread notation.
            This component creates the <code>&lt;a&gt;</code> and <code>&lt;img&gt;</code> tags for the buttons.
          </p>
          
          <a href="https://moreygenetics.com/src/PubButtons.js"
            target="_blank"
            rel="noopener noreferrer"
            style={{"fontWeight":"bold"}}>PubButtons.js</a>
          <pre>{`
class PubButtons extends Component {
  render() {
    let button_list = [];
    (this.props.pubmed) &&
    button_list.push(
      <a href={"https://www.ncbi.nlm.nih.gov/pubmed/?term="+this.props.pubmed}
        key="pubmed" rel="noopener noreferrer" target="_blank">
        <img src={pubmed} alt="PubMed"/>
      </a>
    );
    (this.props.pmc) &&
    button_list.push(
      <a href={"https://www.ncbi.nlm.nih.gov/pmc/articles/"+this.props.pmc}
        key="pmc" rel="noopener noreferrer" target="_blank">
        <img src={pmc} alt="PubMed Central"/>
      </a>
    );
    (this.props.researchgate) &&
    button_list.push(
      <a href={"https://www.researchgate.net/publication/"+this.props.researchgate}
        key="rgate" rel="noopener noreferrer" target="_blank">
        <img src={researchgate} alt="ResearchGate"/>
      </a>
    );
    (this.props.pdf) &&
    button_list.push(
      <a href={"https://moreygenetics.com/pdf/"+this.props.pdf}
        key="pdf" rel="noopener noreferrer" target="_blank">
        <img src={pdf} alt="PDF"/>
      </a>
    );
    (this.props.url) &&
    button_list.push(
      <a href={this.props.url}
        key="url" rel="noopener noreferrer" target="_blank"
        style={{textAlign:"center"}}>
        <span>🌐</span>
      </a>
    );
    
    !((this.props.type) && (this.props.type == "web")) &&
    button_list.push(
      <a href={"https://scholar.google.com/scholar?q="+this.props.title}
        key="google" rel="noopener noreferrer" target="_blank">
        <img src={google} alt="Google Scholar"/>
      </a>
    )

    return (
      <div className="buttons">
        {button_list}
      </div>
    )
  }
}
export default PubButtons;                    
          `}</pre>
          
          <p>
            The <code>Snps</code> component is called with a dictionary prop called <code>snps</code>, as in the example below.
          </p>
          
          <pre>
{`    <Snps snps={{
      "Personality Traits":[
        "rs4680"
      ]
    }} />`}
          </pre>
          
    <Snps snps={{
      "Personality Traits":[
        "rs4680"
      ]
    }} />
          
          <p>
            The <code>componentDidMount()</code> method sends two GET requests to the Python API.
            <br/><br/>
            A list of all SNPs needed in the component is created using a for loop to concatenate each SNP list into the list <code>totalsnps</code>.
            <br/><br/>
            This list is passed to the API as a URL parameter in both GET requests.
          </p>
         
         
         <pre>
{`
    // Create an array of all snp ids needed in this component
    let totalsnps = [];
    let snps_obj = this.props.snps;
    let keys = Object.keys(snps_obj);
    let filenames = (this.props.filenames || []);
    
    for (let i=0;i<keys.length;i++) {
      let snps = [];
      if (Array.isArray(snps_obj[keys[i]])) {
        snps = snps_obj[keys[i]];
      } else {
        snps = snps_obj[keys[i]]["snps"];
        filenames.push(snps_obj[keys[i]]["filename"]);
      }
      
      totalsnps = totalsnps.concat(snps);
    }

    // Request the alleles and genes from api/read_snps.py
    let url = "https://moreygenetics.com/api/read_snps.py?snps="+totalsnps.join(",");
    filenames && (url += "&files=" + filenames.join(","));
    console.log(url);
    
    fetch(url)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            snpsLoaded: true,
            snps: result
          });
        },
        (error) => {
          console.log(error);
          this.setState({
            snpsLoaded:true,
            snpsError:error
          });
        }
      )

    // Request data from api/read_genome.py
    // This request will need the snp ids and (if possible) the facebook access token
    // This returns the alleles from the 23andMe file (or * emoji's if no 23andMe file is available)
    url = "https://moreygenetics.com/api/read_genome.py?snps="+totalsnps.join(",");
    if (this.props.token) {
      url += "&token=" + this.props.token;
    }
    console.log(url);
    
    fetch(url)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            genomeLoaded: true,
            genome: result
          });
        },
        (error) => {
          console.log(error);
          this.setState({
            genomeLoaded:true,
            genomeError:error,
          });
        }
      )
`}
         </pre>
         
          <p>
            The <code>render</code> method will return a div with the id <code>snp_list</code>, which contains a list of divs.
          </p>
          
          <pre>
{`
    let snps_list = [];                 // a list of divs to return
    let snps_obj = this.props.snps;     // an object with snp ids
    const keys = Object.keys(snps_obj);

    for (let i=0;i<keys.length;i++) {
      let snps = (Array.isArray(snps_obj[keys[i]])) ? snps_obj[keys[i]] : snps_obj[keys[i]]["snps"];
      
      // Add the title for each group of SNPs
      snps_list.push(
        <div className="big_title" key={"title"+i}>{keys[i]}</div>
      );
      for (var j=0;j<snps.length;j++) {
        
        var snp_data = this.state.snps[snps[j]];
        //   console.log(snp_data);
        // snp data from the api/read_snps.py request
        // This is an object with the following keys :
        // "chr", "pos"           chromosome number, position
        // "min", "anc", "maf"    minor allele, ancestral allele, minor allele frequency
        // "genes"                a list of objects containing gene names and descriptions

        var genes = {};  // Create an object to store JSX fragments with the gene names and descriptions
        if (snp_data) {
          for (var k=0;k<snp_data["genes"].length;k++) {
            let gene = snp_data["genes"][k];
            genes[gene["name"]] = (
              <React.Fragment key={gene["name"]}>
                <a href={"https://www.ncbi.nlm.nih.gov/gene/?term=("+gene["name"]+"[Gene Name]) AND homo sapiens[Organism]"}
                  target="_blank" rel="noopener noreferrer"
                  >
                  <b>{gene["name"]}</b>&nbsp;{gene["desc"]}
                </a><br/>
              </React.Fragment>
            );
          }
        }

        // state.genome contains the data from the api/read_genome.py request
        var genome = "";
        var genome_keys = Object.keys(this.state.genome);
        if (genome_keys.includes(snps[j])) {
          genome = this.state.genome[snps[j]];
        }

        snps_list.push(
          <div className="snp" key={snps[j]}>
            <SnpButtons snp={snps[j]}/>
            <div className="snpdata"
              id={snps[j]}>
              <div className="title">{snps[j]}</div>
              {
                snp_data&&
                <div className="coords">
                  {snp_data["chr"]} : {snp_data["pos"].replace(/\\B(?=(\\d{3})+(?!\\d))/g, ",")}<br/>
                  {Object.values(genes)}
                  Alleles: {snp_data["alleles"]}<br/>
                  Minor: {snp_data["min"]}<br/>
                  Minor Freq: {snp_data["maf"]}
                </div>
              }
            </div>
            <div className='allele'>{genome}</div>
          </div>
        );
      }
    }

    return (
      <div id="snp_list">
        {snps_list}
      </div>
    );
`}
          </pre>
          
          
        </>
    )
  }
}

export default DocsFrontEnd;
